import DataDeletion from './DataDeletion';
export default DataDeletion;